import { render, staticRenderFns } from "./TagsEditModel.vue?vue&type=template&id=45f9ab3e&scoped=true&"
import script from "./TagsEditModel.vue?vue&type=script&lang=js&"
export * from "./TagsEditModel.vue?vue&type=script&lang=js&"
import style0 from "./TagsEditModel.vue?vue&type=style&index=0&id=45f9ab3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9ab3e",
  null
  
)

export default component.exports